import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../contexts';
import styles from './styles.scoped.css';
import Card from '../../components/elements/Card';
import Select from '../../components/fields/Select';
import LoadingBars from '../../components/elements/LoadingBars';
import { categories } from './constants';
import { thousand } from '../../utils/format';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchCities,
  fetchProvinces,
} from '../../components/layouts/PageBase/actions';
import { fetchStock } from './actions';
import PropTypes from 'prop-types';
import SelectRegion from '../../components/fields/Select/SelectRegion';
import { getRegional, getUserData } from '../../utils/storage';
import { useNavigate } from 'react-router-dom';

export default function Stock() {
  const { setBreadcrumbs } = useContext(AppContext);

  const navigate = useNavigate();
  const isLaAdmin = getUserData()?.isLinkAjaAdmin;
  useEffect(() => {
    if(isLaAdmin){
      navigate('/registrasi-merchant');
    }
  }, [isLaAdmin]);

  const dispatch = useDispatch();

  const { dataProvinces, dataCities } = useSelector((s) => s.pageBase);

  const { dataStock, isLoadingStock } = useSelector((s) => s.stock);

  const userRegion = getRegional();

  const [regional, setRegional] = useState(userRegion);
  const [provinceId, setProvinceId] = useState('');
  const [cityId, setCityId] = useState('');

  useEffect(() => {
    dispatch(fetchProvinces());
    setBreadcrumbs(['Stok Produk']);
  }, []);

  useEffect(() => {
    let params = {
      provinceId,
      cityId,
    };
    if (!userRegion) {
      params.regional = regional;
    }
    dispatch(fetchStock(params));
  }, [regional, provinceId, cityId]);

  useEffect(() => {
    setProvinceId('');
  }, [regional]);

  useEffect(() => {
    setCityId('');
    dispatch(fetchCities(provinceId));
  }, [provinceId]);

  return (
    <main className={styles.root}>
      <Card className={styles.summary}>
        <h5>Stok Produk</h5>
        <div className={styles.filters}>
          <SelectRegion
            eventName="filter_stock_by_region"
            hideLabel
            onChange={(value) => setRegional(value)}
            value={regional}
          />
          <Select
            data={[
              { value: '', name: 'Semua Provinsi', label: 'Semua Provinsi' },
              ...(regional
                ? dataProvinces.filter((p) => p.regional === regional)
                : []),
            ]}
            eventName="filter_stock_by_province"
            hideLabel
            onChange={(event) => setProvinceId(event)}
            value={provinceId}
          />
          <Select
            data={[{ value: '', name: 'Semua Kota/Kab.' }, ...dataCities]}
            eventName="filter_stock_by_city"
            hideLabel
            onChange={(event) => setCityId(event)}
            value={cityId}
          />
        </div>
        <div className={styles['stocks']}>
          {categories.map((rv, index) => (
            <Card
              className={[
                styles[`card-summary`],
                styles[`area-${rv.key}`],
              ].join(' ')}
              key={index}
            >
              <div>
                <h5>Stok {rv.label}</h5>
                {isLoadingStock ? (
                  <LoadingBars className={styles['loading-bars']} size={3} />
                ) : (
                  <div>
                    <h3>
                      {thousand(dataStock[rv.key].totalStock)}
                      <small>{rv.unit}</small>
                    </h3>
                  </div>
                )}
              </div>
              <img alt="revenue" src={rv.icon} />
            </Card>
          ))}
        </div>
      </Card>
      <div className={styles.details}>
        <div>
          {categories
            .filter((category) => category.key !== 'bbm')
            .map((category, index) => (
              <DetailStock
                key={index}
                loading={isLoadingStock}
                name={category.label}
                stock={dataStock[category.key]}
                unit={category.unit}
              />
            ))}
        </div>
        <div>
          <DetailStock
            loading={isLoadingStock}
            name="BBM"
            stock={dataStock['bbm']}
            unit="Liter"
          />
        </div>
      </div>
    </main>
  );
}

DetailStock.propTypes = {
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  stock: PropTypes.shape({
    category: PropTypes.string,
    detail: PropTypes.array,
  }).isRequired,
  unit: PropTypes.string.isRequired,
};

function DetailStock({ loading, name, stock, unit }) {
  return (
    <Card className={styles['detail-stock']}>
      <h5>Detail Stok {name}</h5>
      {loading ? (
        <div>
          <LoadingBars />
        </div>
      ) : (
        <div>
          {stock.detail.length > 0 ? (
            <ul className={styles['products']}>
              {stock?.detail?.map((i, idx) => (
                <li key={idx}>
                  <p>{idx + 1}.</p>
                  <img src={i.image} />
                  <div>
                    <p>{i.nameProduct}</p>
                  </div>
                  <div>
                    <p>
                      {thousand(i.stock)} {unit}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className={styles.empty}>Belum Ada Stok</div>
          )}
        </div>
      )}
    </Card>
  );
}
